import React from 'react';
import moment from 'moment';
import _ from 'lodash';
import LeftDebugChatPanel from '../LeftDebugChatPanel/LeftDebugChatPanel';
import CenteredPanelWithOverlay from '../CenteredPanelWithOverlay/CenteredPanelWithOverlay';
import { CommandInfo } from './CommandInfo';
import OutsideClickPanel from '../../../components/OutsideClickPanel/OutsideClickPanel';
import formats from '../../../../const/formats';
import JsonPanel from '../JsonPanel/JsonPanel';
import JsonPanelHeader from '../JsonPanel/JsonPanelHeader';
import JsonPanelBody from '../JsonPanel/JsonPanelBody';

var $ = require('jquery');

class CommandsPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            opened: false,
            commands: [],
            history: [],
            selectedCommandIndex: 0
        };
    }

    componentDidMount() {
        window.addEventListener('updateCommandsInInfoPanel', this.onCommandsCb, false);
    }

    componentWillUnmount() {
        window.removeEventListener('updateCommandsInInfoPanel', this.onCommandsCb, false);
    }

    onCommandsCb = (e) => {
        const { opened } = this.state;
        let commands, commandInfo, openPanel;

        if (e && e.type === 'updateCommandsInInfoPanel') {
            commands = e.detail.commands || [];
            commandInfo = e.detail.commandInfo;
            openPanel = e.detail.openPanel;

            const panelOpened = !openPanel ? opened : true;

            if (!panelOpened) return;

            this.setState({
                history: commands,
                commands: [...commandInfo.commandData],
                opened: panelOpened,
                selectedCommandIndex: _.findIndex(commands, { ts: commandInfo.ts })
            });
        }
    }

    closePanel = () => {
        const { place } = this.props;

        this.setState({ opened: false });

        if (place === 'chat') {
            window.dispatchEvent(new CustomEvent("scrollDebugChatToRememberedPosition"));
        }
    }

    handleClickOutside = () => {
        const { opened } = this.state;

        if (opened) {
            this.closePanel();
        }
    }

    selectCommand = (e) => {
        const { history } = this.state;
        const curIndex = +e.target.getAttribute('data-index');
        const curCommandTs = +e.target.getAttribute('data-command-ts');

        this.setState({ selectedCommandIndex: curIndex, commands: history[curIndex].commandData });

        window.dispatchEvent(new CustomEvent("scrollDebugChatToBubble", { detail: { ts: curCommandTs } }));
    }

    render() {
        const {
            opened,
            commands,
            history,
            selectedCommandIndex
        } = this.state;
        const { place } = this.props;

        const panelBody = <OutsideClickPanel onOutsideClick={this.handleClickOutside}
            opened={opened}
            classes="outside-click-panel">

            <div className="commands-panel-ext-wrapper">
                {place === 'chat' && <div className="commands-panel_history">
                    <div className="commands-panel_history_header">History</div>
                    <div className="commands-panel_history_list">
                        {history.map((historyEl, index) => {
                            return <div
                                className={`commands-panel_history_list_item ${selectedCommandIndex === index && 'selected'}`}
                                key={historyEl.ts}
                                onClick={this.selectCommand}
                                data-index={index}
                                data-command-ts={historyEl.ts}>
                                {moment(historyEl.ts).format(formats.MM_DD_YY_hh_mm_a)}
                            </div>;
                        })}
                    </div>
                </div>}

                <JsonPanel className="commands-panel" arrow={place === 'chat' ? 'middle' : null}>
                    <JsonPanelHeader title="Commands" onClose={this.closePanel} />
                    <JsonPanelBody>
                        <div className="commands-panel_body" ref="commandsList">
                            {commands.map((command) => {
                                return <CommandInfo
                                    key={command.id}
                                    command={command}
                                    closePanelCb={this.closePanel}
                                />;
                            })}
                        </div>
                    </JsonPanelBody>
                </JsonPanel>
            </div>
        </OutsideClickPanel>;

        if (place === 'tree') {
            return (
                <CenteredPanelWithOverlay opened={opened}>
                    {panelBody}
                </CenteredPanelWithOverlay>
            );
        }

        if (place === 'chat') {
            return (
                <LeftDebugChatPanel opened={opened}>
                    {panelBody}
                </LeftDebugChatPanel>
            );
        }

        return (<div></div>);
    }
}

export default CommandsPanel;
